import React from "react";

import { colors } from "../../../../utils/theme";

/**
 * Sheet R18 (Kelly): the visible empty-state for the Container build tool.
 *
 * Rendered only in the builder (see `shouldShowEmptyPlaceholder`), never on the
 * published Wheel a visitor reads. It gives an otherwise near-invisible empty
 * Container a dashed outline and a plain-language label so the author can see
 * the block exists and knows what to do with it.
 *
 * Styling is inline (not styled-components) for the same reason the sibling
 * EmptyAccordionContainer is: these empty-state hints are asserted as a render
 * contract, and inline style survives static rendering. Colors come from the
 * app's design tokens (utils/theme) — no new palette is introduced here.
 *
 * `pointerEvents: none` is load-bearing: the placeholder is decoration painted
 * inside a craft.js drop target, and it must never intercept the drop it is
 * inviting.
 */
const ContainerEmptyPlaceholder = () => (
  <div
    data-testid="container-empty-placeholder"
    style={{
      flex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100%",
      width: "100%",
      boxSizing: "border-box",
      padding: "16px",
      border: `1px dashed ${colors.PrimaryPurple300}`,
      borderRadius: "6px",
      backgroundColor: colors.PrimaryPurple50,
      color: colors.textGrey,
      fontFamily: "'DM Sans', sans-serif",
      fontSize: "13px",
      fontWeight: 500,
      lineHeight: "20px",
      textAlign: "center",
      pointerEvents: "none",
    }}
  >
    Container — drop content here
  </div>
);

export default ContainerEmptyPlaceholder;
